<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app" :class="vueAppClasses">
    <div v-if="alert.message" :class="`alert ${alert.type}`">{{launchAlert(alert.message, alert.type)}}</div>
		<router-view @setAppClasses="setAppClasses" />

    <modal name="demoEnding" transition="pop-out" :width="800" :focus-trap="true" :height="'auto'" :adaptive="true" :scrollable="true">
      <demoEndingModal></demoEndingModal>
    </modal>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import themeConfig from '@/../themeConfig.js'
import demoEndingModal from "./views/pages/demo/demoEndingModal";

export default {
  components: {
    demoEndingModal
  },
  data() {
    return {
      vueAppClasses: [],
    }
  },
  computed: {
    ...mapState({
      alert: state => {
        return state.alert
      }
    }),
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    '$route' (to, from) {
      this.clearAlert();
    },
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    }
  },
  methods: {
    ...mapActions({
      clearAlert: 'alert/clear'
    }),
    show() {
      this.$modal.show('demoEnding');
    },
    hide() {
      this.$modal.hide('demoEnding');
    },
    launchAlert(message, type) {
      console.log(message);
      if (type === "success") {
        this.$vs.notify({title:'Éxito',text:message, color: type, position:'top-center', time: 15000})
      } else {
        this.$vs.notify({title:'Error',text:message, color: type, position:'top-center', time: 15000})
      }
    },
    toggleClassInBody(className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      }
      else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  async created() {
    let dir = this.$vs.rtl ? "rtl" : "ltr"
    document.documentElement.setAttribute("dir", dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
}

</script>
